export const SET_RENTAL_PLAN_INDEX = 'SET_RENTAL_PLAN_INDEX';
